module.exports = __webpack_public_path__ + "img/thumbnail-1.03e39837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-1.jpg
// module id = 03AS
// module chunks = 1